import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
})
export class LoaderComponent implements OnInit, OnDestroy {
  private service = inject(LoaderService);
  private ref = inject(ChangeDetectorRef);

  loading: boolean = false;
  unsubscribe$: Subject<any> = new Subject();

  ngOnInit() {
    this.service.isLoading.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      this.loading = value;
      this.ref.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(false);
    this.unsubscribe$.complete();
  }
}
